module.exports = __webpack_public_path__ + "img/iOS-share.73d72501.jpeg";